"use client";

// Error components must be Client Components
import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useEffect } from "react";
import ErrorPageIllustration from "@/app/assets/error-page-illustration.svg";
import Button from "@/components/button";
export const metadata = {
  title: "Erreur - Dynabuy Clubs d'affaires",
  description: "Bienvenue sur la page d'erreur des clubs d'affaires de Dynabuy"
};
export default function Error(t0) {
  const $ = _c(6);
  const {
    error,
    reset
  } = t0;
  let t1;
  if ($[0] !== error) {
    t1 = [error];
    $[0] = error;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useEffect(_temp, t1);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Image src={ErrorPageIllustration} alt="Erreur" width={600} height={600} className="mb-10" />;
    t3 = <h1 className="mb-10 text-2xl font-semibold text-center">Une erreur est survenue</h1>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== reset) {
    t4 = <main className="flex min-h-screen flex-col items-center justify-center p-24"><div className="flex flex-col items-center justify-center">{t2}{t3}<Button onClick={() => reset()}>Retourner à la page d'accueil</Button></div></main>;
    $[4] = reset;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}
function _temp() {}